<template>
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card light>
            <v-card-title >
                <v-text-field
                    class="green--text"
                    light
                    box
                    label="Equipos"
                    append-icon="search"
                    v-model="filter"
                ></v-text-field>
            </v-card-title>
            <v-card-text class="pt-0">
                <v-container fluid grid-list-xs>
                    <v-layout row wrap>
                        <v-flex xs12 v-for="(team, i) in filteredTeams" :key="i">
                            <v-card v-if="team.id != oponentTeamId"  light class="team">
                                <v-card-text @click="sendTeam(team)" :style="{ 'display': 'flex', 'align-items': 'center' }">

                                    <div class="team-info-container">
                                        <div
                                            class="fab-img"
                                            :style="{'background-image': 'url(' + team.image + ')'}"
                                        ></div>
                                        <span class="pl-2">{{ team.name }} </span>
                                        <span v-if="currentTournament.mode == 'groups'" class="pl-3">{{team.groupName}}</span>

                                    </div>
                                    <v-badge :overlap="true" right>
                                      <span slot="badge">{{totalMatchesPerTeam(team)}}</span>
                                      <span></span>
                                    </v-badge>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat color="red" @click="cancel">Cancelar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
    export default {
        name: 'AddTeamModal',
        props: {
            dialog: { required: true, default: false },
            teams: { required: true },
            match: {required: true},
            letter: {required: true},
            matches:{required: false}

        },
        data() {
            return {
                filter: '',
                selectedTeam: null,
                oponentTeamId: -1,
                matchesCountPerTeam:[]
            }
        },
        computed: {
            ...mapGetters([
              'currentTournament'
            ]),
            filteredTeams() {
                let allTeams = []
                Object.keys(this.teams).forEach(team => {
                    if(this.filter === '' || this.teams[team].name.toLocaleLowerCase().includes(this.filter.toLocaleLowerCase()))
                        allTeams.push(this.teams[team])
                })

                return allTeams
            }
        },
        methods: {
            sendTeam(team) {
              if(this.letter ==='a'){
                this.match.teamA = team
              }else{
                this.match.teamB = team
              }
              console.log("MATCH",this.match)
              this.$emit('cancel')
            },
            cancel() {
                this.$emit('cancel')
            },
            totalMatchesPerTeam(team){
              if(!this.matches){ return 0 }
              var result = 0
              for(var i in this.matches){
                let match = this.matches[i]
                if(match.teamA && match.teamA.id == team.id){
                  result += 1
                }else if(match.teamB && match.teamB.id == team.id){
                  result += 1
                }
              }
              return result
            }
        },
        watch:{
          dialog(dialog){
            if(dialog == false){return}
            this.oponentTeamId = -1
            if(this.letter ==='a' && this.match.teamB != null){
              this.oponentTeamId = this.match.teamB.id
            }else if(this.letter ==='b' && this.match.teamA != null){
              this.oponentTeamId = this.match.teamA.id
            }

            /*Se hace el conteo de partidos por equipo*/
            /*this.matchesCountPerTeam = []
            if(!this.matches){return}
            for(var i in this.matches){
              let match = this.matches[i]
              if(this.match.teamA && !this.matchesCountPerTeam[match.teamA.id+""]){this.matchesCountPerTeam[match.teamA.id+""] = 0}
              if(match.teamB && !this.matchesCountPerTeam[match.teamB.id+""]){this.matchesCountPerTeam[match.teamB.id+""] = 0}
              this.matchesCountPerTeam[match.teamA.id+""] += 1
              this.matchesCountPerTeam[match.teamB.id+""] += 1
            }*/

          }
        }
    }
</script>

<style lang="css" scoped>
    .fab-img {
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        box-shadow: 0 3px 5px -1px rgba(0,0,0,.2), 0 6px 10px rgba(0,0,0,.14), 0 1px 18px rgba(0,0,0,.12);
    }
    .teams-container {
        height: 500px;
    }
    .team {
        cursor: pointer;
    }
    .team-info-container {
        flex: 1 1 auto;
        display: flex;
        align-items: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/tournaments/tournament_calendar/AddTeamModal.vue